import { buildSrc } from "@imagekit/react";

export const IK_ENDPOINT = "https://ik.imagekit.io/38k93s3fl";

/**
 * Convert a full CDN URL to an ImageKit-relative src using only the filename.
 *
 * Files are uploaded to Spaces as:
 *   https://edge.endpoint/bucket-name/filename.ext
 * ImageKit stores them directly under the root, so the correct src is:
 *   /filename.ext  →  https://ik.imagekit.io/38k93s3fl/filename.ext
 *
 * If the value is falsy, already an IK URL, or has no path segments, it is
 * returned as-is.
 */
export function toIkSrc(url) {
  if (!url) return url;
  if (url.startsWith(IK_ENDPOINT)) return url; // already an IK URL

  if (url.startsWith("http://") || url.startsWith("https://")) {
    try {
      const pathname = new URL(url).pathname; // e.g. /bucket-name/filename.ext
      const filename = pathname.split("/").filter(Boolean).pop(); // "filename.ext"
      if (filename) return `/${filename}`;
    } catch {
      // malformed URL — fall through and return as-is
    }
  }

  return url; // relative path or unknown format — pass through
}

/**
 * Build a fully-resolved ImageKit URL without using a component.
 * Useful for poster images, CSS backgrounds, etc.
 *
 * @param {string} url  - original CDN or relative URL
 * @param {Array}  transformation - ImageKit transformation array
 */
export function ikUrl(url, transformation = []) {
  if (!url) return url;
  return buildSrc({
    urlEndpoint: IK_ENDPOINT,
    src: toIkSrc(url),
    transformation,
  });
}

